import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
	HttpService,
	GET,
	Adapter,
	POST,
	Body,
	Query,
} from "@royalty/httpclient";
import { SmartSearchModel } from "src/app/core/smartsearch/smartsearch";
import { ItemSortOrderRequest } from "@royalty/model";

@Injectable()
export class ItemService extends HttpService {
	/**
	 * Items
	 */

	@POST("item/getAll")
	@Adapter(null, { isAdmin: true })
	getAllItems(@Body data: SmartSearchModel): Observable<any> {
		return null;
	}

	@POST("item/list")
	@Adapter(null, { isAdmin: true })
	getItems(@Body data: SmartSearchModel): Observable<any> {
		return null;
	}

	@GET("item/getbyid")
	@Adapter(null, { isAdmin: true })
	getItem(@Query("id") id: number): Observable<any> {
		return null;
	}

	@GET("item/getsetmenu")
	@Adapter(null, { isAdmin: true })
	getSetMenu(): Observable<any> {
		return null;
	}

	@POST("item/create")
	@Adapter(null, { isAdmin: true })
	createItem(@Body data: string): Observable<any> {
		return null;
	}

	@POST("item/createMutiple")
	@Adapter(null, { isAdmin: true })
	createMutiple(@Body data: string): Observable<any> {
		return null;
	}

	@POST("item/update")
	@Adapter(null, { isAdmin: true })
	updateItem(@Body data: string): Observable<any> {
		return null;
	}

	@POST("item/enable")
	@Adapter(null, { isAdmin: true })
	enableItem(@Body data: string): Observable<any> {
		return null;
	}
	@POST("item/disable")
	@Adapter(null, { isAdmin: true })
	disableItem(@Body data: string): Observable<any> {
		return null;
	}

	@POST("item/canDiscount")
	@Adapter(null, { isAdmin: true })
	canDiscount(@Body data: string): Observable<any> {
		return null;
	}

	@POST("item/notDiscount")
	@Adapter(null, { isAdmin: true })
	notDiscount(@Body data: string): Observable<any> {
		return null;
	}

	@POST("item/setIsSum")
	@Adapter(null, { isAdmin: true })
	setIsSum(@Body data: string): Observable<any> {
		return null;
	}

	@POST("item/disableIsSum")
	@Adapter(null, { isAdmin: true })
	disableIsSum(@Body data: string): Observable<any> {
		return null;
	}

	@POST("item/delete")
	@Adapter(null, { isAdmin: true })
	deleteItem(@Body data: string): Observable<any> {
		return null;
	}

	@POST("item/updateSortOrder")
	@Adapter(null, { isAdmin: true })
	updateSortOrder(@Body data: ItemSortOrderRequest): Observable<any> {
		return null;
	}
}
